const data = {
  "transactions": [
    {
      "id": 1001,
      "project_id": 2,
      "type": "in",
      "date": "2019-06-04",
      "time": "17:08",
      "transaction_type": "New Released From W/h",
      "status_code": 1,
      "update_counter": 1,
      "subheads": [
        1,
        2
      ]
    },
    {
      "id": 1002,
      "project_id": 5,
      "type": "out",
      "date": "2019-06-05",
      "time": "12:35",
      "transaction_type": "Dismantle Returned back From RN Plan",
      "status_code": 2,
      "update_counter": 1,
      "subheads": []
    },
    {
      "id": 1003,
      "project_id": 9,
      "type": "in",
      "date": "2019-09-03",
      "time": "04:27",
      "transaction_type": "New Released From W/h",
      "status_code": 3,
      "update_counter": 1,
      "subheads": [
        3,
        4
      ]
    },
    {
      "id": 1004,
      "project_id": 9,
      "type": "in",
      "date": "2019-09-03",
      "time": "21:02",
      "transaction_type": "New Released From W/h",
      "status_code": 3,
      "update_counter": 1,
      "subheads": [
        5,
        6
      ]
    },
    {
      "id": 1005,
      "project_id": 9,
      "type": "out",
      "date": "2019-09-04",
      "time": "21:02",
      "transaction_type": "",
      "status_code": 2,
      "update_counter": 1,
      "subheads": [
        7
      ]
    },
  ],
  "subheads": [
    {
      "id": 1,
      "transaction_id": 1001,
      "in_subhead_id": 0,
      "mo_num": "11",
      "do_num": "112",
      "source_wh_id": 1,
      "site": "ST1432",
      "site_changed": false,
      "site_dest": "",
      "site_comment": "",
      "lines": [
        1,
        2,
        3
      ]
    },
    {
      "id": 2,
      "transaction_id": 1001,
      "in_subhead_id": 0,
      "mo_num": "113",
      "do_num": "114",
      "source_wh_id": 2,
      "site": "262",
      "site_changed": false,
      "site_dest": "",
      "site_comment": "",
      "lines": [
        4,
        5
      ]
    },
    {
      "id": 3,
      "transaction_id": 1003,
      "in_subhead_id": 0,
      "mo_num": "qws",
      "do_num": "sad",
      "source_wh_id": 5,
      "site": "",
      "site_changed": null,
      "site_dest": "",
      "site_comment": "",
      "lines": [
        6,
        7,
        8,
        9
      ]
    },
    {
      "id": 4,
      "transaction_id": 1003,
      "in_subhead_id": 0,
      "mo_num": "1",
      "do_num": "2",
      "source_wh_id": 0,
      "site": "",
      "site_changed": null,
      "site_dest": "",
      "site_comment": "",
      "lines": [
        10,
        11,
        12
      ]
    },
    {
      "id": 5,
      "transaction_id": 1004,
      "in_subhead_id": 0,
      "mo_num": "",
      "do_num": "",
      "source_wh_id": 0,
      "site": "",
      "site_changed": null,
      "site_dest": "",
      "site_comment": "",
      "lines": [
        13,
        14,
        15
      ]
    },
    {
      "id": 6,
      "transaction_id": 1004,
      "in_subhead_id": 0,
      "mo_num": "",
      "do_num": "",
      "source_wh_id": 0,
      "site": "",
      "site_changed": null,
      "site_dest": "",
      "site_comment": "",
      "lines": [
        16
      ]
    },
    {
      "id": 7,
      "transaction_id": 1005,
      "in_subhead_id": 0,
      "mo_num": "",
      "do_num": "",
      "source_wh_id": 0,
      "site": "",
      "site_changed": true,
      "site_dest": "asq",
      "site_comment": "",
      "lines": [
        17
      ]
    }
  ],
  "lines": [
    {
      "id": 1,
      "transaction_id": 1001,
      "subhead_id": 1,
      "in_line_id": 0,
      "item_id": 19,
      "description": "",
      "qty": 3,
      "stock": 3,
      "serials": [],
      "material_condition": "New",
      "material_condition_comment": "",
      "packing_status": "Packed",
      "packing_status_comment": "",
      "location": "1",
    },
    {
      "id": 2,
      "transaction_id": 1001,
      "subhead_id": 1,
      "in_line_id": 0,
      "item_id": 2,
      "description": "",
      "qty": 5,
      "stock": 5,
      "serials": ["www1"],
      "material_condition": "Scrape",
      "material_condition_comment": "fgfg",
      "packing_status": "UnPacked",
      "packing_status_comment": "4545",
      "location": "2",
    },
    {
      "id": 3,
      "transaction_id": 1001,
      "subhead_id": 1,
      "in_line_id": 0,
      "item_id": 2,
      "description": "",
      "qty": 2,
      "stock": 2,
      "serials": ["1111", "2222"],
      "material_condition": "",
      "material_condition_comment": "",
      "packing_status": "",
      "packing_status_comment": "",
      "location": "3",
    },
    {
      "id": 4,
      "transaction_id": 1001,
      "subhead_id": 2,
      "in_line_id": 0,
      "item_id": 7,
      "description": "",
      "qty": 6,
      "stock": 6,
      "serials": [],
      "material_condition": "New",
      "material_condition_comment": "",
      "packing_status": "",
      "packing_status_comment": "",
      "location": "4",
    },
    {
      "id": 5,
      "transaction_id": 1001,
      "subhead_id": 2,
      "in_line_id": 0,
      "item_id": 7,
      "description": "",
      "qty": 4,
      "stock": 4,
      "serials": [],
      "material_condition": "Faulty",
      "material_condition_comment": "ff",
      "packing_status": "",
      "packing_status_comment": "",
      "location": "5",
    },
    {
      "id": 6,
      "subhead_id": 3,
      "transaction_id": 1003,
      "in_line_id": 0,
      "item_id": 10,
      "description": "",
      "qty": 1,
      "stock": 1,
      "serials": [],
      "material_condition": "New",
      "material_condition_comment": "",
      "packing_status": "",
      "packing_status_comment": "",
      "location": "",
    },
    {
      "id": 7,
      "subhead_id": 3,
      "transaction_id": 1003,
      "in_line_id": 0,
      "item_id": 8,
      "description": "",
      "qty": 3,
      "stock": 3,
      "serials": [],
      "material_condition": "Used",
      "material_condition_comment": "",
      "packing_status": "Packed",
      "packing_status_comment": "",
      "location": "",
    },
    {
      "id": 8,
      "subhead_id": 3,
      "transaction_id": 1003,
      "in_line_id": 0,
      "item_id": 2,
      "description": "",
      "qty": 2,
      "stock": 2,
      "serials": ["111", "123"],
      "material_condition": "",
      "material_condition_comment": "",
      "packing_status": "",
      "packing_status_comment": "",
      "location": "",
    },
    {
      "id": 9,
      "subhead_id": 3,
      "transaction_id": 1003,
      "in_line_id": 0,
      "item_id": 1,
      "description": "",
      "qty": 2,
      "stock": 2,
      "serials": [],
      "material_condition": "New",
      "material_condition_comment": "",
      "packing_status": "",
      "packing_status_comment": "",
      "location": "",
    },
    {
      "id": 10,
      "subhead_id": 4,
      "transaction_id": 1003,
      "in_line_id": 0,
      "item_id": 4,
      "description": "",
      "qty": 1,
      "stock": 1,
      "serials": [],
      "material_condition": "",
      "material_condition_comment": "",
      "packing_status": "",
      "packing_status_comment": "",
      "location": "",
    },
    {
      "id": 11,
      "subhead_id": 4,
      "transaction_id": 1003,
      "in_line_id": 0,
      "item_id": 1,
      "description": "",
      "qty": 1,
      "stock": 1,
      "serials": [],
      "material_condition": "",
      "material_condition_comment": "",
      "packing_status": "",
      "packing_status_comment": "",
      "location": "",
    },
    {
      "id": 12,
      "subhead_id": 4,
      "transaction_id": 1003,
      "in_line_id": 0,
      "item_id": 2,
      "description": "",
      "qty": 1,
      "stock": 1,
      "serials": [],
      "material_condition": "",
      "material_condition_comment": "",
      "packing_status": "",
      "packing_status_comment": "",
      "location": "",
    },
    {
      "id": 13,
      "subhead_id": 5,
      "transaction_id": 1004,
      "in_line_id": 0,
      "item_id": 1,
      "description": "",
      "qty": 1,
      "stock": 1,
      "serials": [],
      "material_condition": "New",
      "material_condition_comment": "",
      "packing_status": "Packed",
      "packing_status_comment": "",
      "location": "123",
    },
    {
      "id": 14,
      "subhead_id": 5,
      "transaction_id": 1004,
      "in_line_id": 0,
      "item_id": 4,
      "description": "",
      "qty": 2,
      "stock": 2,
      "serials": ["111", "222", "333"],
      "material_condition": "Scrape",
      "material_condition_comment": "sdsdsad",
      "packing_status": "UnPacked",
      "packing_status_comment": "zaas",
      "location": "123wq",
    },
    {
      "id": 15,
      "subhead_id": 5,
      "transaction_id": 1004,
      "in_line_id": 0,
      "item_id": 3,
      "description": "",
      "qty": 4,
      "stock": 4,
      "serials": [],
      "material_condition": "",
      "material_condition_comment": "",
      "packing_status": "",
      "packing_status_comment": "",
      "location": "231e",
    },
    {
      "id": 16,
      "subhead_id": 6,
      "transaction_id": 1004,
      "in_line_id": 0,
      "item_id": 5,
      "description": "",
      "qty": 3,
      "stock": 3,
      "serials": [],
      "material_condition": "Faulty",
      "material_condition_comment": "zsas",
      "packing_status": "Packed",
      "packing_status_comment": "",
      "location": "aqsa",
    },
    {
      "id": 17,
      "subhead_id": 7,
      "transaction_id": 1005,
      "in_line_id": 14,
      "item_id": 4,
      "description": "",
      "qty": 2,
      "stock": 2,
      "serials": ["111", "222"],
      "material_condition": "Scrape",
      "material_condition_comment": "sdsdsad",
      "packing_status": "UnPacked",
      "packing_status_comment": "zaas",
      "location": "123wq",
    },
  ],
  "serials": [
    {
      "type": "in",
      "serial": "www1",
      "transaction_id": 1001,
      "line_id": 2
    },
    {
      "type": "in",
      "serial": "1111",
      "transaction_id": 1001,
      "line_id": 3
    },
    {
      "type": "in",
      "serial": "2222",
      "transaction_id": 1001,
      "line_id": 3
    },
    {
      "type": "in",
      "serial": "111",
      "transaction_id": 1004,
      "line_id": 14
    },
    {
      "type": "in",
      "serial": "222",
      "transaction_id": 1004,
      "line_id": 14
    },
    {
      "type": "in",
      "serial": "333",
      "transaction_id": 1004,
      "line_id": 14
    },
    {
      "type": "out",
      "serial": "111",
      "transaction_id": 1005,
      "line_id": 17
    },
    {
      "type": "out",
      "serial": "222",
      "transaction_id": 1005,
      "line_id": 17
    },
    {
      "type": "in",
      "serial": "111",
      "transaction_id": 1003,
      "line_id": 8
    },
    {
      "type": "in",
      "serial": "123",
      "transaction_id": 1003,
      "line_id": 8
    },
  ]
}

const {transactions, subheads, lines, serials} = data;

const id = {
  transactions: (transactions[transactions.length -1] || {id: 0}).id,
  subheads: (subheads[subheads.length -1] || {id: 0}).id,
  lines: (lines[lines.length -1] || {id: 0}).id,
};

const new_id = (table) => ++id[table];

const templates = {
  head: {
    "id": 0,
    "project_id": 0,
    "type": "",
    "date": "",
    "time": "",
    "transaction_type": "",
    "status_code": 0,
    "update_counter": 1,
    "subheads": [],
  },
  subhead: {
    "id": 0,
    "transaction_id": 0,
    "in_subhead_id": 0,
    "mo_num": "",
    "do_num": "",
    "source_wh_id": 0,
    "site": "",
    "site_changed": null,
    "site_dest": "",
    "site_comment": "",
    "lines": [],
  },
  line: {
    "id": 0,
    "subhead_id": 0,
    "transaction_id": 0,
    "in_line_id": 0,
    "item_id": 0,
    "description": "",
    "qty": 0,
    "stock": 0,
    "serials": [],
    "material_condition": "",
    "material_condition_comment": "",
    "packing_status": "",
    "packing_status_comment": "",
    "location": "",
  },
};

const template = (name, data) => {
  const t = {...templates[name]};
  Object.keys(t).forEach(key => {
    if (key in data) {
      t[key] = data[key];
    }
  });
  return t;
};

export default {
  transactions,
  subheads,
  lines,
  serials,
  id,
  new_id,
  template,
}
